import { Component, OnInit } from '@angular/core';
import { AttendanceService } from '../../services/attendance.service';
import { AttendanceSummaryModel } from '../../models/attendance-model';
import { AttendanceCalendarModel } from '../../models/attendance-calendar-model';
import { DatePipe } from '@angular/common';
import { MenuUtils } from '../../../../../utils/menu-utils';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { PageHeadingService } from '../../../../../services/page-heading-service/page-heading.service';
import { SchoolInfoService } from 'src/app/modules/common/school-logo/school-info.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-attendance-details',
  templateUrl: './attendance-details.component.html',
  styleUrls: ['./attendance-details.component.scss'],
  providers: [DatePipe]
})
export class AttendanceDetailsComponent extends ComponentBase implements OnInit {

  constructor(private attendanceService: AttendanceService
    , private datePipe: DatePipe
    , private pageHeadingService: PageHeadingService
    , private institutionService: SchoolInfoService
  ) {
    super();
  }
  attendanceSummaryModel: AttendanceSummaryModel;
  attendanceCalendarModel: AttendanceCalendarModel[][][];
  dayNames = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
  noOfDaysPresent: number = 0;
  noOfDaysAbsent: number = 0;
  loading: boolean = true;
  showCarriedForwardMsg: boolean = false;
  snackBarClass: string = "";
  snackBarMessage: string = "";
  timeoutId: ReturnType<typeof setTimeout>;

  ngOnInit() {
    this.pageHeadingService.menuOnChange(MenuUtils.getMenuItem("Attendance"));
    let institutionsub = this.institutionService.getInstitutionInfo().subscribe(res=>{
      this.showCarriedForwardMsg = res.site_url.includes('sophia');
    })
    this.addSubscription(institutionsub);
    let subscription = this.attendanceService.getAttendanceForAcademicYear()
      .subscribe(res => {
        this.loading = false;
        this.attendanceSummaryModel = res;
        if (this.attendanceSummaryModel.attendance_summary) {
          //add custom carried forward message for sophia school for classes 9,10,12 of academic year 24-25
          if(this.showCarriedForwardMsg){
            this.showCarriedForwardMsg = [369,370,372,373,374].includes(this.attendanceSummaryModel.attendance_summary[0].batch_term_id);
          }
          this.noOfDaysPresent = this.attendanceSummaryModel.attendance_summary.filter(o => o.attendance_status == 1).length;
          this.noOfDaysAbsent = this.attendanceSummaryModel.attendance_summary.filter(o => o.attendance_status == 2).length;
          this.generateCalendar();
        }
      });
    this.addSubscription(subscription);
  }

  generateCalendar() {
    let startDate = new Date(this.attendanceSummaryModel.start_year, this.attendanceSummaryModel.start_month - 1, 1);
    let endDate = new Date(this.attendanceSummaryModel.end_year, this.attendanceSummaryModel.end_month, 0);
    let months = endDate.getMonth() - startDate.getMonth() + (12 * (endDate.getFullYear() - startDate.getFullYear())) + 1;
    var year = [];
    for (var i = 0; i < months; i++) {
      year.push(this.getMonths(startDate));
      startDate.setMonth(startDate.getMonth() + 1);
    }
    this.attendanceCalendarModel = year;
  }

  getMonths(monthStartDate: Date) {
    var daysInCurrentMonth = this.getDaysInMonth(monthStartDate.getMonth(), monthStartDate.getFullYear());
    var daysInFirstWeek = monthStartDate.getDay() ? (7 - monthStartDate.getDay() + 1) : 1;
    var weeks = [];
    if (daysInFirstWeek < 7) {
      weeks.push([]);
      for (var i = 1; i <= 7; i++) {
        if (weeks[0].length < 7 - daysInFirstWeek) {
          weeks[0].push(new AttendanceCalendarModel());
        } else {
          weeks[0].push(daysInCurrentMonth.splice(0, 1)[0]);
        }
      }
    }
    while (daysInCurrentMonth.length > 0) {
      weeks.push(daysInCurrentMonth.splice(0, 7));
    }
    for (i = weeks[weeks.length - 1].length; i < 7; i++) {
      weeks[weeks.length - 1].push(new AttendanceCalendarModel());
    }
    return weeks;
  }

  getDaysInMonth(month, year): Array<Date> {
    var date = new Date(year, month, 1);
    var days = [];
    while (date.getMonth() === month) {
      let day = new AttendanceCalendarModel();
      day.date = new Date(date);
      day.attendance_summary = this.attendanceSummaryModel.attendance_summary.find(o => {
        return o.attendance_date.split('T')[0] == this.datePipe.transform(day.date, "yyyy-MM-dd");
      })
      days.push(day);
      date.setDate(date.getDate() + 1);
    }
    return days;
  }

  getMonthName(month: AttendanceCalendarModel[][]) {
    return this.datePipe.transform(month[0].find(o => !!o.date).date, "MMMM")
  }

  getYearName(month: AttendanceCalendarModel[][]) {
    return this.datePipe.transform(month[0].find(o => !!o.date).date, "yyyy")
  }

  getDayClass(day: AttendanceCalendarModel) {
    if (day.date && day.attendance_summary && !(this.showCarriedForwardMsg && day.date < new Date(2024,4,18))) {
      if (day.attendance_summary.attendance_status == 1) {
        return "present";
      }
      else if (day.attendance_summary.attendance_status == 2) {
        return "absent";
      }
    }
  }

  public showSnackBar(message: string) {
    clearTimeout(this.timeoutId);
    this.snackBarClass = "show";
    this.snackBarMessage = message;
    new Observable((observable) => {
      this.timeoutId = setTimeout(() => {
        this.snackBarClass = "hide";
        this.snackBarMessage = "";
        observable.complete();
      }, 3000);
    }).subscribe();
  }
}
